import React, { Component } from 'react';
import { GraingerAccountContext } from '../../Context/Context';

import PropTypes from 'prop-types';

import './Button.scss';
import Link from '../Link/Link';

class Button extends Component {
  render() {
    const { children, page } = this.props;
    
    return (
      <Link page={page}>
        <button className='button'>{children}</button>
      </Link>
    );
  }
}

Button.propTypes = {
  children: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired
};

Button.contextType = GraingerAccountContext;
export default Button;